import dayjs from 'dayjs';

import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import { FeatureOrOrganizationFlagGuard } from '@packages/components/feature-or-organization-flag-guard/feature-or-organization-flag-guard';

import { CustomAlertBase } from './components/custom-alert-base';
import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'custom-alerts',
      element: (
        <FeatureOrOrganizationFlagGuard
          featureFlag="CUSTOM_ALERTS"
          organizationFlag={{ customAlerts: true }}
        >
          <LegacyCapabilitiesGuard
            capabilities={{
              canAccessAnalyzedData: true,
            }}
          >
            <CustomAlertBase />
          </LegacyCapabilitiesGuard>
        </FeatureOrOrganizationFlagGuard>
      ),
      children: [
        {
          index: true,
          lazy: () => import('./pages/custom-alerts.page'),
        },
        {
          path: ':alertId',
          lazy: () => import('./pages/custom-alert-detail.page'),
        },
      ],
    },
  ],
  navigation: ({ featureFlags, organization, legacyCapabilities }) => ({
    ticketsAlerts: {
      customAlerts:
        (featureFlags?.CUSTOM_ALERTS || organization?.flags.customAlerts) &&
        legacyCapabilities?.canAccessAnalyzedData
          ? {
              title: i18n.t('custom-alerts:title'),
              segment: '/custom-alerts',
            }
          : null,
    },
  }),
  whatsNew: ({ featureFlags, organization, legacyCapabilities }) => {
    if (featureFlags?.CUSTOM_ALERTS || organization?.flags.customAlerts) {
      return [
        {
          newsItemId: 'customAlerts',
          date: dayjs('2025-06-13T00:00:00Z'),
          hasAccess: !!legacyCapabilities?.canAccessAnalyzedData,
        },
      ];
    }

    return [];
  },
} satisfies FeatureConfig;
